import axios from 'axios'

export default {
    getAll: () => axios.get(`/carousel`),
    add: formData => axios.post(`/carousel/create`, formData),
    edit: formData => axios.put(`/carousel/edit`, formData),
    delete: id => axios.delete(`/carousel/${id}`)
}
